import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.99 4V20C21.99 21.1 21.0905 22 19.991 22H3.999C2.89955 22 2 21.1 2 20V12H4.009V20H19.991V4H12.005V2H20.001C21.1004 2 22 2.9 22 4H21.99ZM11.995 17H18.9915L15.4933 12.55L13.994 14.46L10.5957 10.01L4.9985 17.01H11.995V17ZM4.9985 10H7.0075V7H10.006V4.99H7.0075V2H4.9985V5H2V7.01H4.9985V10.01V10Z" fill={ fill || 'currentColor' } />
    </svg>
);
